import { ClickEvent, LinkEvent, PageEvent, PerformanceEvent } from '@/types/events';
import { NinjaInstance } from '@/types/global.ts';
import { dataLayer } from './dataLayer';
import { getInfo } from './getInfo';
import { startNinja } from './startNinja';

function trackEvent(eventName: string, params: Record<string, unknown> = {}) {
  if (eventName) {
    const trackParams: ClickEvent = Object.assign({}, params, {
      trackEvent: Array.isArray(eventName) ? eventName : [eventName],
    });
    dataLayer.push(trackParams);
  }
}

function trackPage(name: string, params: Record<string, unknown> = {}) {
  const trackParams: PageEvent = Object.assign({}, params, { trackPage: name });

  dataLayer.push(trackParams);
}

function trackLinkEvent(name: string, params: Record<string, unknown> = {}) {
  const trackParams: LinkEvent = Object.assign({}, params, { trackLinkEvent: name });

  dataLayer.push(trackParams);
}

function trackPerformanceEvent(name: string, params: Record<string, unknown> = {}) {
  const trackParams: PerformanceEvent = Object.assign({}, params, { trackPerformanceEvent: name });

  dataLayer.push(trackParams);
}

queueMicrotask(() => {
  void startNinja();
});

export default {
  getInfo,
  trackEvent,
  trackPage,
  trackLinkEvent,
  trackPerformanceEvent,
} satisfies NinjaInstance;
